import React from 'react';
import { Modal, Button, Form } from 'antd';
import { SelectWhatsappService } from 'components/select';

const ModalFilter = ({ values, visible, hideModal, setTempTableFilter, setTableFilterFromTemp }) => {
    return (
        <Modal
            title="Filter"
            width={300}
            open={visible}
            onCancel={hideModal}
            footer={<>
                <Button onClick={hideModal}>Tutup</Button>
                <Button type='primary' onClick={setTableFilterFromTemp}>Terapkan</Button>
            </>}
        >
            <Form
                name="basic"
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item label="Service" name="whatsapp_service_id">
                    <SelectWhatsappService
                        allowClear
                        defaultValue={values.whatsapp_service_id}
                        value={values.whatsapp_service_id}
                        onChange={(val) => {
                            setTempTableFilter("whatsapp_service_id", val || null)
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalFilter;
